import { useEffect, useState } from "react";
import api from "@/lib/api";
import { rupees } from "@/lib/helpers";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { QrCode, Copy } from "@phosphor-icons/react";

export function PayCard() {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/portal/payment").then(({ data }) => setP(data)).catch(() => {}); }, []);
  if (!p) return null;
  const copy = async () => {
    try { await navigator.clipboard.writeText(p.upi_id); toast.success("UPI ID copied"); }
    catch { window.prompt("Copy the UPI ID:", p.upi_id); }
  };
  return (
    <Card className="p-6 bg-white border-[#E6E2D6] shadow-sm mb-6" data-testid="portal-pay-card">
      <div className="flex items-center gap-2 text-sm font-semibold text-[#1A1A1A] mb-4"><QrCode size={18} className="text-[#C5A059]" /> Scan &amp; Pay your installment</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
        <img src={p.qr_image} alt="OM GOLD UPI QR code" className="w-full max-w-[280px] mx-auto rounded-md border border-[#E6E2D6]" data-testid="portal-pay-qr" />
        <div>
          <div className="text-[10px] uppercase tracking-wider text-[#8A8A8A]">Amount due now</div>
          <div className="text-3xl font-medium tabular-nums text-[#8A6D2F] mt-1" data-testid="portal-total-due">{rupees(p.total_due)}</div>
          <div className="mt-3 space-y-2">
            {p.dues.length === 0 && <div className="text-sm text-[#8A8A8A]">No installment due right now.</div>}
            {p.dues.map((d) => (
              <div key={d.account_no} className="flex justify-between text-sm border-b border-[#F2EBE1] pb-2" data-testid={`portal-due-${d.account_no}`}>
                <span><span className="font-medium">{d.account_no}</span> <span className="text-[#8A8A8A]">· Inst #{d.installment_no} · due {d.due_date.slice(0, 10)}</span></span>
                <span className="tabular-nums">{rupees(d.amount)}</span>
              </div>
            ))}
          </div>
          <div className="mt-4 text-xs text-[#6B6B6B]">UPI ID</div>
          <div className="flex items-center gap-2 mt-1">
            <code className="text-xs bg-[#F8F6F0] px-2 py-1 rounded break-all" data-testid="portal-upi-id">{p.upi_id}</code>
            <Button size="icon" variant="ghost" onClick={copy} data-testid="portal-copy-upi"><Copy size={15} /></Button>
          </div>
          <p className="text-[11px] text-[#8A8A8A] mt-3">Scan the QR with any UPI app, enter the amount above and pay. Share the payment screenshot with the showroom so they can record your installment.</p>
        </div>
      </div>
    </Card>
  );
}
